export enum Layouts {
  DEFAULT = 'default',
  SIGN_UP = 'auth',
}
